import React, {} from 'react';
import { FaHtml5 } from 'react-icons/fa'; 
import { Gi3DGlasses, GiVrHeadset, GiSmartphone } from 'react-icons/gi'; 
const About = () => {
  return (
    <>
    <div class="parent-about">
        <h1>About</h1>
        <p>I am a student studying computer engineering. I know how to use many computer languages like C, C++, Java, HTML/CSS, Python, SQL, React JS, and MySQL. Besides programming, I also understand Augmented Reality (AR) and Virtual Reality (VR) technologies. I've practiced making AR/VR apps. I know a lot about programming. Playing E-sports and learning new things are my hobbies.</p>
        <p>I like to use my skills to solve problems and help with new projects. I'm excited to learn more and try new things!</p>
        <h3>What I Do!</h3>
    </div>
    <div class="child-about">
        <div class="sub-child-about">
            <div class="sub-child-about-1">
                <div class="about">
                    <span><FaHtml5 /></span>
                </div>
                <div class="about1">
                    <h2>Web Development</h2>
                </div>
            </div>
            <p>I craft responsive websites and dynamic web applications with HTML, CSS, JavaScript and React, focusing on user experience.</p>
        </div>
        <div class="sub-child-about">
            <div class="sub-child-about-1">
                <div class="about">
                    <span style={{color: "#0dcaf0"}}><Gi3DGlasses /></span>
                </div>
                <div class="about1">
                    <h2>Augmented Reality</h2>
                </div>
                </div>
            <p>Augmented Reality (AR) enhances real-world experiences by overlaying digital information onto the user's environment.</p>
        </div>
        <div class="sub-child-about">
            <div class="sub-child-about-1">
                <div class="about">
                    <span style={{color: "#ffc107"}}><GiVrHeadset /></span>
                </div>
                <div class="about1">
                    <h2>Virtual Reality</h2>
                </div>
                </div>
            <p>Augmented Reality (AR) enhances real-world experiences by overlaying digital information onto the user's environment.</p>
        </div>
        <div class="sub-child-about">
            <div class="sub-child-about-1">
                <div class="about">
                    <span style={{color: "#d63384"}}><GiSmartphone /></span>
                </div>
                <div class="about1">
                    <h2>App Development</h2>
                </div>
                </div>
            <p>App development entails designing, coding, and deploying software solutions for mobile devices or other platforms and performance.</p>
        </div>
    </div>
    </>
  );
};

export default About;
